export default __webpack_public_path__ + "514fdc3c0bea3c34f9f87d6371e0a56e.png";